import { ReactElement } from 'react';

import { Checkbox } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../../../translations';

export type DateConfirmedWithPatientFieldFormBeanPart = {
   dateConfirmedWithPatient: boolean;
};

type DateConfirmedWithPatientFieldProps = {
   register: BindingCreator<DateConfirmedWithPatientFieldFormBeanPart>;
};

export const DateConfirmedWithPatientField = (props: DateConfirmedWithPatientFieldProps): ReactElement => {
   return (
      <Checkbox
         testId={'dateConfirmedWithPatient'}
         label={appointmentsTranslationKeys.create.form.dateConfirmedWithPatient.label}
         controller={props.register('dateConfirmedWithPatient')}
         defaultValue={false}
      />
   );
};
